import React from "react";

const Meta = ({ ogTitle, ogDescription, title, description, canonical }) => {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle ? ogTitle : title} />
      <meta
        property="og:description"
        content={ogDescription ? ogDescription : description}
      />
      <meta name="twitter:title" content={ogTitle ? ogTitle : title} />
      <meta
        name="twitter:description"
        content={ogDescription ? ogDescription : description}
      />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={ogTitle ? ogTitle : title} />
      {canonical && <link rel="canonical" href={canonical} />}
    </>
  );
};

export default Meta;
